import React, { useState } from 'react';
import LayersIcon from '@mui/icons-material/Layers';
import Fade from '@mui/material/Fade';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import PropTypes from 'prop-types';
import LayerSwitcher from './LayerSwitcher';
import styles from './LayerSwitcherCtrl.module.scss';

export default function LayerSwitcherControl() {
  const [isOpen, setIsOpen] = useState(false);
  const onClick = () => setIsOpen(!isOpen);

  return (
    <>
      <Paper elevation={4} sx={{ p: '2px' }}>
        <IconButton color="primary" aria-label="layers" title="Gestion des couches" onClick={onClick}>
          <LayersIcon />
        </IconButton>
      </Paper>
      <Fade in={isOpen}>
        <Paper elevation={4} className={styles.content}>
          <LayerSwitcher />
        </Paper>
      </Fade>
    </>
  );
}

LayerSwitcherControl.propTypes = {
  map: PropTypes.object,
};
